import { render, staticRenderFns } from "./assessmentApply.vue?vue&type=template&id=84dfd9ec"
import script from "./assessmentApply.vue?vue&type=script&lang=js"
export * from "./assessmentApply.vue?vue&type=script&lang=js"
import style0 from "./assessmentApply.vue?vue&type=style&index=0&id=84dfd9ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports